






import Vue from "vue";
import Chart from "chart.js/auto";
import "chartjs-adapter-date-fns";
import { add, format } from "date-fns";

import ResizeObserver from "resize-observer-polyfill";
(window as any).ResizeObserver = ResizeObserver;

export default Vue.extend<any, any, any, any>({
  name: "SkillsLineGraph",
  props: {
    chartData: {
      type: Object,
      default: null
    },
    type: {
      type: Number,
      default: undefined
    }
  },

  data() {
    let min = new Date();
    let max = add(min, { days: 90 });

    if (this.chartData.datasets[0].data[0]) {
      min = this.chartData.datasets[0].data[0].x;
      max = add(min, { days: 90 });
    }

    return {
      options: {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            callbacks: {
              label(context: any) {
                return `${context.raw.y}`;
              },
              title(context: any[]) {
                return format(context[0].raw.x, "MM月dd日");
              }
            }
          }
        },
        responsive: true,
        scales: {
          x: {
            grid: {
              drawOnChartArea: false
            },
            max,
            min,
            ticks: {
              autoSkip: false,
              autoSkipPadding: 15,
              maxRotation: 0
            },
            time: {
              displayFormats: {
                day: "MM月dd日"
              },
              unit: "day"
            },
            type: "time"
          },
          y: {
            grid: {
              borderDash: [3, 3]
            },
            min: 0,
            ticks: {
              maxTicksLimit: 4,
              stepSize: 1,
              suggestedMin: 0
            }
          }
        }
      }
    };
  },

  mounted() {
    const chart = new Chart(this.$refs.chart, {
      type: "line",
      data: this.chartData,
      options: this.options
    });

    chart.canvas.parentNode.style.height = "80px";
  }
});
